import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { createFileRoute } from "@tanstack/react-router";
import { InboxGrid } from "@/features/inbox/InboxGrid";

function InboxPage() {
  return (
    <Container maxWidth="lg" disableGutters>
      <Typography variant="h4" component="h1" gutterBottom>
        Inbox
      </Typography>
      <InboxGrid />
    </Container>
  );
}

export const Route = createFileRoute("/_authed/inbox")({
  component: InboxPage,
});
